/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightCancellationResponse
 */
export interface FlightCancellationResponse {
  /**
   * Persisted supplier execution mode; test consumers require an affirmative acknowledgment.
   * @type {boolean}
   * @memberof FlightCancellationResponse
   */
  test?: boolean;
  /**
   *
   * @type {number}
   * @memberof FlightCancellationResponse
   */
  schemaVersion: FlightCancellationResponseSchemaVersionEnum;
  /**
   *
   * @type {string}
   * @memberof FlightCancellationResponse
   */
  bookingId: string;
  /**
   *
   * @type {string}
   * @memberof FlightCancellationResponse
   */
  cancellationId: string;
  /**
   *
   * @type {string}
   * @memberof FlightCancellationResponse
   */
  cancellationRequestId: string;
  /**
   *
   * @type {string}
   * @memberof FlightCancellationResponse
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof FlightCancellationResponse
   */
  refundStatus: string;
  /**
   *
   * @type {string}
   * @memberof FlightCancellationResponse
   */
  scope: FlightCancellationResponseScopeEnum;
  /**
   *
   * @type {number}
   * @memberof FlightCancellationResponse
   */
  affectedPassengerCount?: number | null;
  /**
   *
   * @type {number}
   * @memberof FlightCancellationResponse
   */
  affectedSegmentCount?: number | null;
  /**
   *
   * @type {number}
   * @memberof FlightCancellationResponse
   */
  affectedTicketCount?: number | null;
  /**
   *
   * @type {number}
   * @memberof FlightCancellationResponse
   */
  affectedFareComponentCount?: number | null;
  /**
   *
   * @type {number}
   * @memberof FlightCancellationResponse
   */
  affectedAncillaryCount?: number | null;
  /**
   *
   * @type {string}
   * @memberof FlightCancellationResponse
   */
  penaltyAmount?: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightCancellationResponse
   */
  expectedRefundAmount?: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightCancellationResponse
   */
  refundedAmount?: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightCancellationResponse
   */
  currency?: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightCancellationResponse
   */
  refundMethod?: string | null;
  /**
   * Ticket-document settlement progress, independent from refund status and returned money. Omission means no authoritative ticket-settlement update is available.
   * @type {string}
   * @memberof FlightCancellationResponse
   */
  ticketSettlementStatus?: FlightCancellationResponseTicketSettlementStatusEnum;
  /**
   * Bounded ticket-document settlement method. A void does not imply a refund, payout, or known returned amount.
   * @type {string}
   * @memberof FlightCancellationResponse
   */
  ticketSettlementMethod?: FlightCancellationResponseTicketSettlementMethodEnum | null;
  /**
   * Count of ticket documents in the authoritative settlement scope; document IDs are never exposed.
   * @type {number}
   * @memberof FlightCancellationResponse
   */
  ticketSettlementAffectedCount?: number;
  /**
   * Count with authoritative settlement evidence; this is not a refunded or paid amount.
   * @type {number}
   * @memberof FlightCancellationResponse
   */
  ticketSettlementSettledCount?: number;
  /**
   *
   * @type {Date}
   * @memberof FlightCancellationResponse
   */
  quoteExpiresAt?: Date | null;
  /**
   *
   * @type {boolean}
   * @memberof FlightCancellationResponse
   */
  confirmable: boolean;
  /**
   *
   * @type {boolean}
   * @memberof FlightCancellationResponse
   */
  supportRequired?: boolean;
  /**
   *
   * @type {string}
   * @memberof FlightCancellationResponse
   */
  assistanceReasonCode?: string | null;
}

/**
 * @export
 */
export const FlightCancellationResponseSchemaVersionEnum = {
  NUMBER_1: 1,
} as const;
export type FlightCancellationResponseSchemaVersionEnum =
  (typeof FlightCancellationResponseSchemaVersionEnum)[keyof typeof FlightCancellationResponseSchemaVersionEnum];

/**
 * @export
 */
export const FlightCancellationResponseScopeEnum = {
  WholeOrder: "whole_order",
} as const;
export type FlightCancellationResponseScopeEnum =
  (typeof FlightCancellationResponseScopeEnum)[keyof typeof FlightCancellationResponseScopeEnum];

/**
 * @export
 */
export const FlightCancellationResponseTicketSettlementStatusEnum = {
  NotRequired: "not_required",
  Pending: "pending",
  VoidPending: "void_pending",
  Voided: "voided",
  NeedsAttention: "needs_attention",
} as const;
export type FlightCancellationResponseTicketSettlementStatusEnum =
  (typeof FlightCancellationResponseTicketSettlementStatusEnum)[keyof typeof FlightCancellationResponseTicketSettlementStatusEnum];

/**
 * @export
 */
export const FlightCancellationResponseTicketSettlementMethodEnum = {
  Void: "void",
} as const;
export type FlightCancellationResponseTicketSettlementMethodEnum =
  (typeof FlightCancellationResponseTicketSettlementMethodEnum)[keyof typeof FlightCancellationResponseTicketSettlementMethodEnum];

/**
 * Check if a given object implements the FlightCancellationResponse interface.
 */
export function instanceOfFlightCancellationResponse(
  value: object
): value is FlightCancellationResponse {
  if (!("schemaVersion" in value) || value["schemaVersion"] === undefined)
    return false;
  if (!("bookingId" in value) || value["bookingId"] === undefined) return false;
  if (!("cancellationId" in value) || value["cancellationId"] === undefined)
    return false;
  if (
    !("cancellationRequestId" in value) ||
    value["cancellationRequestId"] === undefined
  )
    return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("refundStatus" in value) || value["refundStatus"] === undefined)
    return false;
  if (!("scope" in value) || value["scope"] === undefined) return false;
  if (!("confirmable" in value) || value["confirmable"] === undefined)
    return false;
  return true;
}

export function FlightCancellationResponseFromJSON(
  json: any
): FlightCancellationResponse {
  return FlightCancellationResponseFromJSONTyped(json, false);
}

export function FlightCancellationResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightCancellationResponse {
  if (json == null) {
    return json;
  }
  return {
    test: json["test"] == null ? undefined : json["test"],
    schemaVersion: json["schema_version"],
    bookingId: json["booking_id"],
    cancellationId: json["cancellation_id"],
    cancellationRequestId: json["cancellation_request_id"],
    status: json["status"],
    refundStatus: json["refund_status"],
    scope: json["scope"],
    affectedPassengerCount:
      json["affected_passenger_count"] == null
        ? undefined
        : json["affected_passenger_count"],
    affectedSegmentCount:
      json["affected_segment_count"] == null
        ? undefined
        : json["affected_segment_count"],
    affectedTicketCount:
      json["affected_ticket_count"] == null
        ? undefined
        : json["affected_ticket_count"],
    affectedFareComponentCount:
      json["affected_fare_component_count"] == null
        ? undefined
        : json["affected_fare_component_count"],
    affectedAncillaryCount:
      json["affected_ancillary_count"] == null
        ? undefined
        : json["affected_ancillary_count"],
    penaltyAmount:
      json["penalty_amount"] == null ? undefined : json["penalty_amount"],
    expectedRefundAmount:
      json["expected_refund_amount"] == null
        ? undefined
        : json["expected_refund_amount"],
    refundedAmount:
      json["refunded_amount"] == null ? undefined : json["refunded_amount"],
    currency: json["currency"] == null ? undefined : json["currency"],
    refundMethod:
      json["refund_method"] == null ? undefined : json["refund_method"],
    ticketSettlementStatus:
      json["ticket_settlement_status"] == null
        ? undefined
        : json["ticket_settlement_status"],
    ticketSettlementMethod:
      json["ticket_settlement_method"] == null
        ? undefined
        : json["ticket_settlement_method"],
    ticketSettlementAffectedCount:
      json["ticket_settlement_affected_count"] == null
        ? undefined
        : json["ticket_settlement_affected_count"],
    ticketSettlementSettledCount:
      json["ticket_settlement_settled_count"] == null
        ? undefined
        : json["ticket_settlement_settled_count"],
    quoteExpiresAt:
      json["quote_expires_at"] == null
        ? undefined
        : new Date(json["quote_expires_at"]),
    confirmable: json["confirmable"],
    supportRequired:
      json["support_required"] == null ? undefined : json["support_required"],
    assistanceReasonCode:
      json["assistance_reason_code"] == null
        ? undefined
        : json["assistance_reason_code"],
  };
}

export function FlightCancellationResponseToJSON(
  json: any
): FlightCancellationResponse {
  return FlightCancellationResponseToJSONTyped(json, false);
}

export function FlightCancellationResponseToJSONTyped(
  value?: FlightCancellationResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    test: value["test"],
    schema_version: value["schemaVersion"],
    booking_id: value["bookingId"],
    cancellation_id: value["cancellationId"],
    cancellation_request_id: value["cancellationRequestId"],
    status: value["status"],
    refund_status: value["refundStatus"],
    scope: value["scope"],
    affected_passenger_count: value["affectedPassengerCount"],
    affected_segment_count: value["affectedSegmentCount"],
    affected_ticket_count: value["affectedTicketCount"],
    affected_fare_component_count: value["affectedFareComponentCount"],
    affected_ancillary_count: value["affectedAncillaryCount"],
    penalty_amount: value["penaltyAmount"],
    expected_refund_amount: value["expectedRefundAmount"],
    refunded_amount: value["refundedAmount"],
    currency: value["currency"],
    refund_method: value["refundMethod"],
    ticket_settlement_status: value["ticketSettlementStatus"],
    ticket_settlement_method: value["ticketSettlementMethod"],
    ticket_settlement_affected_count: value["ticketSettlementAffectedCount"],
    ticket_settlement_settled_count: value["ticketSettlementSettledCount"],
    quote_expires_at:
      value["quoteExpiresAt"] == null
        ? value["quoteExpiresAt"]
        : value["quoteExpiresAt"].toISOString(),
    confirmable: value["confirmable"],
    support_required: value["supportRequired"],
    assistance_reason_code: value["assistanceReasonCode"],
  };
}
